import React, { useState } from "react";
import Modal from "react-modal";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { icons } from "../../assets/icons";
import TextArea from "../../components/FormFields/TextArea";
import CustomButton from "../../components/CustomButton";
import useApi from "../../hooks/useApi";
import { toast } from "react-toastify";
import { apiUrls } from "../../utils/api/apiUrls";
import { Link, useNavigate } from "react-router-dom";
import { CustomPdfViewer } from "../../../srcWeb/components/CustomPdfViewer/CustomPdfViewer";

let imageFormats = ["png", "jpeg", "jpg"];
let previewPossibleFormats = ["png", "jpeg", "jpg", "pdf"];

const PreviewModal = ({ isModalVisible, setIsModalVisible }) => {
  const [rejectedComment, setRejectedComment] = useState("");
  const navigate = useNavigate();
  const modalData = isModalVisible;
  var file = new File([modalData?.file], modalData?.filename);
  const { apiCall: voucherStatusApi, apiCall: attachmentSignedUrl } = useApi();
  const onRequestClose = () => {
    setIsModalVisible(false);
  };

  const voucherStatusApiCall = (payload, status) => {
    voucherStatusApi({
      url: apiUrls.dmsService.approveRequest,
      dataToSend: payload,
      method: "post",
      onSuccess: () => {
        toast.success(status);
        setIsModalVisible(false);
        navigate("/vouchers");
      },
    });
  };

  const approveRequestHandler = () => {
    console.log("approved request handler");
    let payload = {
      approved: [{ id: modalData.id, approvedAmount: modalData.amount }],
      comment: "",
      rejected: [],
      approvedAmount: null,
    };
    voucherStatusApiCall(payload, "Approved Voucher Successfully");
  };
  const rejectRequestHandler = () => {
    if (!rejectedComment) {
      toast.error("Please enter reject comment");
      return;
    }
    console.log("rejected request handler");
    let payload = {
      approved: [],
      comment: rejectedComment,
      rejected: [modalData?.id],
    };
    voucherStatusApiCall(payload, "Rejected Voucher Successfully");
  };

  const { filename = " " } = modalData;
  const lastIndex = filename.split(".").length;
  const format = filename.split(".")[lastIndex - 1];
  const isFileNotImage = imageFormats?.includes(format);
  const previewPossible = previewPossibleFormats?.includes(format);

  const getSignedUrl = () => {
    attachmentSignedUrl({
      url: apiUrls.dmsService.getSignedUrl + "/" + modalData?.id,
      method: "get",
      onSuccess: (apiData) => {
        window.open(apiData, "_blank");
      },
    });
  };

  return (
    <div className="flex justify-center items-center w-full">
      <Modal
        isOpen={isModalVisible}
        onRequestClose={onRequestClose}
        style={{
          content: {
            display: "flex",
            justifyContent: "center",
            borderRadius: "1rem",
            background: "#fff",
            padding: "2rem",
            inset: "30px 20px",
          },
          overlay: {
            background: "#000000 0% 0% no-repeat padding-box",
            zIndex: 99,
          },
        }}
      >
        <div className="flex flex-col w-full grow gap-y-10">
          <button className="open-in-new-tab-fixed" onClick={getSignedUrl}>
            Open in a new tab
          </button>
          <div
            className="text-3xl cursor-pointer text-red"
            style={{
              alignItems: "flex-end",
              height: "20px",
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => setIsModalVisible(false)}
          >
            CLOSE [x]
          </div>
          {previewPossible ? (
            <div className="flex border-[1px] border-[#000] !h-[48%] max-h-[48%] justify-center relative">
              {isFileNotImage ? (
                <TransformWrapper
                  initialPositionX={0}
                  initialPositionY={0}
                  onZoomStart={true}
                >
                  {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                    <React.Fragment>
                      <div className="flex items-center absolute top-[0.8rem] left-[1rem] z-10 gap-x-3">
                        <img
                          src={icons.zoomInIcon}
                          onClick={() => zoomIn()}
                          alt="zoom icon"
                          className="cursor-pointer"
                        />
                        <img
                          src={icons.zoomOutIcon}
                          onClick={() => zoomOut()}
                          alt="zoom icon"
                          className="cursor-pointer"
                        />
                      </div>
                      <Link
                        to={`/view-image?image=${URL.createObjectURL(file)}`}
                        target="_blank"
                        className="absolute top-[0.8rem] right-[1.5rem] z-10"
                      >
                        <img
                          src={icons.fullscreenIcon}
                          alt="fullscreen icon"
                          className="cursor-pointer"
                        />
                      </Link>
                      <TransformComponent
                        contentClass="w-[100%] h-[100%]"
                        wrapperClass="w-[100%] h-[100%]"
                      >
                        {file ? (
                          <img
                            style={{
                              height: "100%",
                              width: "100%",
                              objectFit: "contain",
                            }}
                            src={URL.createObjectURL(file)}
                            alt="attachment"
                          />
                        ) : null}
                      </TransformComponent>
                    </React.Fragment>
                  )}
                </TransformWrapper>
              ) : (
                <div className="overflow-auto ">
                  <CustomPdfViewer file={modalData.file} />
                </div>
              )}
            </div>
          ) : (
            <div className="flex border-[1px] border-[#000] !h-[48%] max-h-[48%] justify-center relative">
              <p className="text-lg">
                Preview not available. Please download the File to Review
              </p>
            </div>
          )}
          <div className="flex flex-col gap-y-5 w-full !h-[50%] max-h-[45%] px-4">
            <div className="flex justify-between">
              <div>
                <div className="text-[1.1rem] text-[#797979]">VOUCHER HEAD</div>
                <div className="font-size-small font-family-medium">
                  {modalData?.head}
                </div>
              </div>
            </div>
            {/* <div>
              <div className="text-[1.1rem] text-[#797979]">
                VOUCHER SUB-HEAD
              </div>
              <div className="font-size-small font-family-medium">
                {modalData?.sub_head}
              </div>
            </div> */}
            <div>
              <div className="text-[1.1rem] text-[#797979]">DATE</div>
              <div className="font-size-small font-family-medium">
                {modalData?.date}
              </div>
            </div>
            <div>
              <div className="text-[1.1rem] text-[#797979]">AMOUNT (₹)</div>
              <div className="font-size-small font-family-medium">
                {modalData?.amount}
              </div>
            </div>
            <div>
              <div className="text-[1.1rem] text-[#797979]">COMMENT</div>
              <div className="font-size-small font-family-medium">
                {modalData?.comment}
              </div>
            </div>
            <div className="w-[100%] h-[1px] bg-[var(--borderGray1)]" />
            <TextArea
              title="ADD COMMENT"
              rows="1"
              showRemaining={false}
              containerClassName="!bg-[#fff] border-[1px] !border-[var(--borderGray1)]"
              labelClassName="!text-[1.1rem] text-[#797979]"
              onChange={(e) => {
                setRejectedComment(e);
              }}
              value={rejectedComment}
            />
            <div className="flex items-center mt-4 justify-between pb-8">
              <CustomButton
                title="Reject"
                textClassName="!text-[var(--textRed)]"
                wrapperClassName="w-[42%] border-[1px] !border-[var(--textRed)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
                onClick={rejectRequestHandler}
              />
              <CustomButton
                title="Approve"
                textClassName="!text-[var(--successGreen)]"
                onClick={approveRequestHandler}
                wrapperClassName="w-[50%] border-[1px] !border-[var(--successGreen)] !bg-transparent self-end !text-[var(--blackColor)] !px-8"
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PreviewModal;
